import { useEffect, useReducer, useState } from 'react';
import axios from 'axios';
import { dataFetchReducer } from './data';
import { systemCode, xs_languageCode } from '..';
import { getConfiguration } from './utils';
import { parseAgendaStreamingData } from './parseAgendaStreamingData';

export function useFetchAgendaLiveStreaming() {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    const [isSetInterval,setIsSetInterval] = useState(false);
    
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const getData = () => {
            const data = getFromStorage();
            if(data === null){
                const url = getConfiguration().api.getAgendaLiveStreaming;
                const params = {
                    systemCode,
                    lingua: xs_languageCode,
                    hash: ''
                };
                fetchData(url, params, function(response) {
                    const payloadData = response || response.data || {};
                    setInStorage(payloadData);
                    const parsedData = parseAgendaStreamingData(payloadData);
                    dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
                });
            }else{
                let parsedData = {};
                try {
                    parsedData = parseAgendaStreamingData(data);
                }catch(err){
                    parsedData = {};
                    clearFromStorage();
                    console.error(err);
                }
                dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
            }
        }

        /*const getData = () => {
            clearFromStorage();
            const url = getConfiguration().api.getAgendaLiveStreaming;
            const params = {
                systemCode,
                lingua: 'IT',
                hash: ''
            };
            fetchData(url, params, function(response) {
                const payloadData = response || response.data || {};
                const parsedData = parseAgendaStreamingData(payloadData);
                dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
            });
        }*/

        getData();

        const interval =   setInterval(() => {
            setIsSetInterval(true);
            getData();
        }, intervalMillis);

        return () => {
            didCancel = true;
            clearInterval(interval)
            setIsSetInterval(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [state, dispatch, isSetInterval];
}

//const intervalMillis = getConfiguration()?.lpo ?? 10000;


const storageKey = 'x_als_last_fetched';

const intervalMillis = 300000 // 5 minutes

function getFromStorage(){
    let item = localStorage.getItem(storageKey) || null;

    if(item === null)
        return null;

    item = JSON.parse(item);
    const now = Date.now()
    if(Math.floor((now - item.timestamp)) > intervalMillis-(intervalMillis/10)){
            return null;
    }else{
        return item.data
    }
}

function setInStorage(data){
    const item = {
        timestamp: Date.now(),
        data: data
    };
    localStorage.setItem(storageKey,JSON.stringify(item))
}



function clearFromStorage(){
    localStorage.removeItem(storageKey)
}
